import { ArrowRightOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import { Form, Input, Button, Select } from 'antd';
import classNames from 'classnames';

export default function Stap2(props) {
    const { TextArea } = Input;
    const { Option } = Select;

    const onNextStep = () => {
        props.form.validateFields().then(() => {
            props.calProgress(40);
            props.nextStep();
        });
    };

    const onPreviousStep = () => {
        props.calProgress(0);
        props.previousStep();
    };
    //customForm
    //customStyle
    //fontStyle
    return (
        <div
            className="rounded-md p-5 h-full"
            style={{
                backgroundColor: props?.customStyle?.bgColor, //bgColor
            }}
        >
            <div
                className="space-y-3"
                style={{
                    color: props?.fontStyle?.textCardColor,
                }}
            >
                <div className="text-xl font-bold px-3">
                    2.{' '}
                    {props.lang === 'TH'
                        ? 'ข้อมูลเกี่ยวกับเจ้าของข้อมูลส่วนบุคคล'
                        : 'Information of the Data Subject'}
                </div>
                <div style={{ border: '1px solid #DBDBDB' }}></div>
                <Form
                    scrollToFirstError={{
                        behavior: 'smooth',
                        block: 'center',
                    }}
                    name="step2"
                    form={props.form}
                    layout="vertical"
                    className="px-3"
                >
                    <div
                        className="font-bold text-xl"
                        style={{
                            color: props?.fontStyle?.textCardColor,
                        }}
                    >
                        {props.lang === 'TH'
                            ? 'ข้อมูลเกี่ยวกับเจ้าของข้อมูลส่วนบุคคล'
                            : 'Information of the Data Subject'}
                    </div>
                    <Form.Item
                        name="dataSubjectTypeId"
                        rules={[
                            {
                                required: true,
                                message:
                                    props.lang === 'TH'
                                        ? 'กรุณากรอกข้อมูลให้ครบถ้วน'
                                        : 'This field is required.',
                            },
                        ]}
                        label={
                            <div
                                className="font-bold"
                                style={{
                                    color: props?.fontStyle?.textCardColor,
                                    fontSize: props?.fontStyle?.fontSize,
                                }}
                            >
                                {props.lang === 'TH'
                                    ? 'เลือกประเภทเจ้าของข้อมูล'
                                    : 'Select Data Subject Type'}
                            </div>
                        }
                    >
                        <Select
                            size="large"
                            placeholder={
                                props.lang === 'TH'
                                    ? 'เลือกประเภทเจ้าของข้อมูล'
                                    : 'Select Data Subject Type'
                            }
                            showSearch
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                                (option?.children ?? '')
                                    .toLowerCase()
                                    .includes(input.toLowerCase())
                            }
                        >
                            {props?.personalTypeList?.map((res) => (
                                <Option key={res?.id} value={res?.id}>
                                    {res?.name}
                                </Option>
                            ))}
                            {/* <Option value="1">พนักงาน</Option>
                        <Option value="2">ลูกค้า</Option>
                        <Option value="3">
                            คู่ค้าหรือพันธมิตรทางธุรกิจ
                        </Option> */}
                        </Select>
                    </Form.Item>
                    <div
                        className="text-xl font-bold pb-1"
                        style={{
                            color: props?.fontStyle?.textCardColor,
                        }}
                    >
                        {props.lang === 'TH'
                            ? 'กรณีเจ้าของข้อมูลเป็นบุคคลเดียวกับผู้ยื่นคำร้อง ไม่ต้องกรอกส่วนนี้  '
                            : 'Contact Details of Data Subject (if you are the data subject, skip this part)'}
                    </div>
                    {/* Firstname Lastname */}
                    <div className="sm:block md:grid sm:grid-cols-1 md:grid-cols-2">
                        <Form.Item
                            hidden={!props?.customForm?.display?.staffId}
                            label={
                                <div
                                    className="font-bold"
                                    style={{
                                        color: props?.fontStyle?.textCardColor,
                                        fontSize: props?.fontStyle?.fontSize,
                                    }}
                                >
                                    {props.lang === 'TH'
                                        ? 'รหัสพนักงาน'
                                        : 'Staff ID'}
                                </div>
                            }
                            name="staffId"
                            rules={[
                                {
                                    required:
                                        props?.customForm?.display?.staffId,
                                    message:
                                        props.lang === 'TH'
                                            ? 'กรุณากรอกข้อมูลให้ครบถ้วน'
                                            : 'This field is required.',
                                },
                            ]}
                        >
                            <Input
                                size="large"
                                // disabled={
                                //     props.formStep1.getFieldsValue()
                                //         ?.applicantRole === 0
                                // }
                                placeholder={
                                    props.lang === 'TH'
                                        ? 'รหัสพนักงาน'
                                        : 'Staff ID'
                                }
                            />
                        </Form.Item>
                    </div>
                    <div className="sm:block md:grid sm:grid-cols-1 md:grid-cols-2 gap-x-3">
                        <Form.Item
                            label={
                                <div
                                    className="font-bold"
                                    style={{
                                        color: props?.fontStyle?.textCardColor,
                                        fontSize: props?.fontStyle?.fontSize,
                                    }}
                                >
                                    {props.lang === 'TH' ? 'ชื่อ' : 'Name'}
                                </div>
                            }
                            name="firstName"
                            rules={[
                                {
                                    required: true,
                                    message:
                                        props.lang === 'TH'
                                            ? 'กรุณากรอกข้อมูลให้ครบถ้วน'
                                            : 'This field is required.',
                                },
                            ]}
                        >
                            <Input
                                size="large"
                                // disabled={
                                //     props.formStep1.getFieldsValue()
                                //         ?.applicantRole === 0
                                // }
                                placeholder={
                                    props.lang === 'TH' ? 'ชื่อ' : 'Name'
                                }
                            />
                        </Form.Item>
                        <Form.Item
                            label={
                                <div
                                    className="font-bold"
                                    style={{
                                        color: props?.fontStyle?.textCardColor,
                                        fontSize: props?.fontStyle?.fontSize,
                                    }}
                                >
                                    {props.lang === 'TH'
                                        ? 'นามสกุล'
                                        : 'Surname'}
                                </div>
                            }
                            name="lastName"
                            rules={[
                                {
                                    required: true,
                                    message:
                                        props.lang === 'TH'
                                            ? 'กรุณากรอกข้อมูลให้ครบถ้วน'
                                            : 'This field is required.',
                                },
                            ]}
                        >
                            <Input
                                size="large"
                                // disabled={
                                //     props.formStep1.getFieldsValue()
                                //         ?.applicantRole === 0
                                // }
                                placeholder={
                                    props.lang === 'TH' ? 'นามสกุล' : 'Surname'
                                }
                            />
                        </Form.Item>
                    </div>
                    {/* Address */}
                    <div className="sm:block md:grid grid-cols-1">
                        <Form.Item
                            hidden={!props?.customForm?.display?.address}
                            label={
                                <div
                                    className="font-bold"
                                    style={{
                                        color: props?.fontStyle?.textCardColor,
                                        fontSize: props?.fontStyle?.fontSize,
                                    }}
                                >
                                    {props.lang === 'TH'
                                        ? 'ที่อยู่'
                                        : 'Address'}
                                </div>
                            }
                            name="address"
                            rules={[
                                {
                                    required:
                                        props?.customForm?.display?.address,
                                    message:
                                        props.lang === 'TH'
                                            ? 'กรุณากรอกข้อมูลให้ครบถ้วน'
                                            : 'This field is required.',
                                },
                            ]}
                        >
                            <Input
                                size="large"
                                // disabled={
                                //     props.formStep1.getFieldsValue()
                                //         ?.applicantRole === 0
                                // }
                                placeholder={
                                    props.lang === 'TH' ? 'ที่อยู่' : 'Address'
                                }
                            />
                        </Form.Item>
                    </div>
                    {/* Telephone Email */}
                    <div className="sm:block md:flex">
                        <Form.Item
                            //flex-basis phone check by email
                            style={{
                                flexBasis: !props?.customForm?.display?.email
                                    ? '50%'
                                    : '50%',
                            }}
                            hidden={!props?.customForm?.display?.phone}
                            label={
                                <div
                                    className="font-bold"
                                    style={{
                                        color: props?.fontStyle?.textCardColor,
                                        fontSize: props?.fontStyle?.fontSize,
                                    }}
                                >
                                    {props.lang === 'TH'
                                        ? 'หมายเลขโทรศัพท์'
                                        : 'Telephone number'}
                                </div>
                            }
                            name="phone"
                            rules={[
                                {
                                    // ^[0-9]\d*$
                                    pattern: new RegExp(/^[0-9]\d*$/),
                                    message:
                                        props.lang === 'TH'
                                            ? 'กรุณากรอกข้อมูลให้ถูกต้อง'
                                            : 'Phone is not a valid.',
                                },
                                {
                                    required: props?.customForm?.display?.phone,
                                    message:
                                        props.lang === 'TH'
                                            ? 'กรุณากรอกข้อมูลให้ครบถ้วน'
                                            : 'This field is required.',
                                },
                            ]}
                        >
                            <Input
                                maxLength={10}
                                size="large"
                                // disabled={
                                //     props.formStep1.getFieldsValue()
                                //         ?.applicantRole === 0
                                // }
                                placeholder={
                                    props.lang === 'TH'
                                        ? 'หมายเลขโทรศัพท์'
                                        : 'Telephone number'
                                }
                            />
                        </Form.Item>
                        <Form.Item
                            //flex-basis,padding email check by phone
                            style={{
                                flexBasis: !props?.customForm?.display?.phone
                                    ? '50%'
                                    : '50%',
                            }}
                            className={classNames('sm:pl-0 md:pl-3', {
                                'sm:pl-0 md:pl-0':
                                    !props?.customForm?.display?.phone,
                            })}
                            // hidden={!props?.customForm?.display?.email}
                            hidden={false}
                            label={
                                <div
                                    className="font-bold"
                                    style={{
                                        color: props?.fontStyle?.textCardColor,
                                        fontSize: props?.fontStyle?.fontSize,
                                    }}
                                >
                                    {props.lang === 'TH' ? 'อีเมล' : 'Email'}
                                </div>
                            }
                            name="email"
                            rules={[
                                { type: 'email' },
                                {
                                    required: true,
                                    message:
                                        props.lang === 'TH'
                                            ? 'กรุณากรอกข้อมูลให้ครบถ้วน'
                                            : 'This field is required.',
                                },
                            ]}
                        >
                            <Input
                                size="large"
                                // disabled={
                                //     props.formStep1.getFieldsValue()
                                //         ?.applicantRole === 0
                                // }
                                placeholder={
                                    props.lang === 'TH' ? 'อีเมล' : 'Email'
                                }
                            />
                        </Form.Item>
                    </div>
                    {/* CardID */}
                    <div className="sm:block md:grid grid-cols-1">
                        <Form.Item
                            hidden={!props?.customForm?.display?.cardId}
                            label={
                                <div
                                    style={{
                                        color: props?.fontStyle?.textCardColor,
                                        fontSize: props?.fontStyle?.fontSize,
                                    }}
                                    className="font-bold"
                                >
                                    {props.lang === 'TH'
                                        ? 'หมายเลขบัตรประจำตัวประชาชน / passport'
                                        : 'Identification Number / passport'}
                                </div>
                            }
                            name="cardId"
                            rules={[
                                {
                                    required:
                                        props?.customForm?.display?.cardId,
                                    message:
                                        props.lang === 'TH'
                                            ? 'กรุณากรอกข้อมูลให้ครบถ้วน'
                                            : 'This field is required.',
                                },
                            ]}
                        >
                            <Input
                                maxLength={13}
                                size="large"
                                placeholder={
                                    props.lang === 'TH'
                                        ? 'หมายเลขบัตรประจำตัวประชาชน / passport'
                                        : 'Identification Number / passport'
                                }
                            />
                        </Form.Item>
                    </div>
                    {/* Infomation */}
                    <Form.Item
                        hidden={!props?.customForm?.display?.detail}
                        label={
                            <div
                                className="font-bold"
                                style={{
                                    color: props?.fontStyle?.textCardColor,
                                    fontSize: props?.fontStyle?.fontSize,
                                }}
                            >
                                {props.lang === 'TH'
                                    ? 'รายละเอียดอื่น (ถ้ามี)'
                                    : 'Additional details (if any)'}
                            </div>
                        }
                        name="remark"
                    >
                        <TextArea
                            size="large"
                            // disabled={
                            //     props.formStep1.getFieldsValue()?.applicantRole === 0
                            // }
                            autoSize={{ minRows: 5 }}
                            placeholder={
                                props.lang === 'TH'
                                    ? 'รายละเอียดอื่น'
                                    : 'Additional details'
                            }
                        />
                    </Form.Item>
                    <div className="flex space-x-4 py-4">
                        <Button
                            // className="text-[#7B67FB] border-[#7B67FB]"
                            style={{
                                borderColor: props?.customStyle?.buttonColor,
                                color: props?.customStyle?.buttonColor,
                            }}
                            className="w-[120px]"
                            type="default"
                            size="large"
                            onClick={onPreviousStep}
                        >
                            <ArrowLeftOutlined />{' '}
                            {props.lang === 'TH' ? 'ย้อนกลับ' : 'Previous'}
                        </Button>
                        <Button
                            style={{
                                backgroundColor:
                                    props?.customStyle?.buttonColor,
                                color: props?.fontStyle?.textButtonColor,
                                borderColor: props?.customStyle?.buttonColor,
                            }}
                            className="w-[120px]"
                            type="primary"
                            size="large"
                            onClick={onNextStep}
                        >
                            {props.lang === 'TH' ? 'ถัดไป' : 'Next'}{' '}
                            <ArrowRightOutlined />
                        </Button>
                    </div>
                </Form>
            </div>
        </div>
    );
}
